import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-firewall-connections-status-report',
  templateUrl: './summary-firewall-connections-status-report.component.html',
  styleUrls: ['./summary-firewall-connections-status-report.component.scss']
})
export class SummaryFirewallConnectionsStatusReportComponent {

  constructor() { }
}
